var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2 28.6C2.32 28.6 1.56693 28.2869 0.9408 27.6608C0.314667 27.0347 0.00106667 26.2811 0 25.4V6.2C0 5.32 0.3136 4.56693 0.9408 3.9408C1.568 3.31467 2.32107 3.00107 3.2 3H28.8C29.68 3 30.4336 3.3136 31.0608 3.9408C31.688 4.568 32.0011 5.32107 32 6.2V25.4C32 26.28 31.6869 27.0336 31.0608 27.6608C30.4347 28.288 29.6811 28.6011 28.8 28.6H3.2ZM16 17.4L3.2 9.4V25.4H28.8V9.4L16 17.4ZM16 14.2L28.8 6.2H3.2L16 14.2ZM3.2 9.4V6.2V25.4V9.4Z",
    fill: "#AE5257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.3f1ce974ff9667a341f501d444087098.svg";
export { ForwardRef as ReactComponent };